import { makeStyles } from "tss-react/mui";

interface IParams {
    height: number;
}

export const useStyle = makeStyles<IParams>()((theme, { height }) => ({
    homeBackground: {
        backgroundColor: theme.palette.secondary.main,
        position: "absolute",
        width: "100%",
        height,
    },
    bannerCloseButton: {
        color: theme.palette.secondary.main,
        position: "absolute",
        width: "44px",
        height: "44px",
        top: "10px",
        right: "10px",
        zIndex: 10,
        padding: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& svg": {
            margin: "auto",
        },
    },
    closeIcon: {
        color: theme.palette.secondary.main,
        width: "24px",
        height: "24px",
    },
    bannerContainer: {
        position: "relative",
    },
    recommendationBannerRemovalModal: {
        display: "contents",
    },
}));
